var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAUserAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-a-UserAdd",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M448 192c141.184 0 256 114.816 256 256a254.208 254.208 0 0 1-64.128 167.744c142.976 60.928 234.816 187.264 234.816 344.256a64 64 0 0 1-64 64H64a64 64 0 0 1-64-64c0-159.872 100.48-290.624 251.648-349.76A253.44 253.44 0 0 1 192 448c0-141.184 114.816-256 256-256z m-10.688 512c-152.32 0-268.992 77.696-300.8 192h601.984c-30.784-115.712-146.112-192-301.184-192zM448 320c-70.528 0-128 57.408-128 128s57.472 128 128 128c70.592 0 128-57.408 128-128s-57.408-128-128-128z m384-320a64 64 0 0 1 64 64v64h64a64 64 0 1 1 0 128h-64v64a64 64 0 1 1-128 0V256h-64a64 64 0 1 1 0-128h64V64a64 64 0 0 1 64-64z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAUserAdd);
export default __webpack_public_path__ + "static/media/a-UserAdd.f29d9a6f79a46fa888a026081aaf4fc9.svg";
export { ForwardRef as ReactComponent };